var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('dpa-account-form',{attrs:{"loading":_vm.loading,"dpaAccountData":_vm.dpaAccount,"formErrors":_vm.formErrors},on:{"dpaAccountSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }